import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramariBlocareComponent } from './programari-blocare.component';
import { AddProgramariBlocareComponent } from './add-programari-blocare/add-programari-blocare.component';
import { EditProgramariBlocareComponent } from './edit-programari-blocare/edit-programari-blocare.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

@NgModule({
    declarations: [
        ProgramariBlocareComponent,
        AddProgramariBlocareComponent,
        EditProgramariBlocareComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxMatTimepickerModule
    ],
    exports: [ProgramariBlocareComponent],
})
export class ProgramariBlocareModule { }
